export const SET_USER_PROFESSIONAL_FIELD = 'setUserProfessionalField';
export const SET_USER_PROFESSIONAL_FIELD_LICENSE = 'setProfessionalFieldLicense';

export const setUserProfessionalField = (userProfessionalField) => {
     return {
          type: SET_USER_PROFESSIONAL_FIELD,
          payload: userProfessionalField,
     };
};

export const setUserProfessionalFieldLicense = (userProfessionalFieldLicense) => {
     return {
          type: SET_USER_PROFESSIONAL_FIELD_LICENSE,
          payload: userProfessionalFieldLicense,
     };
};
